var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_54763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4865 10.1871C20.4865 9.36767 20.4184 8.76973 20.2712 8.14966H10.6992V11.848H16.3178C16.2045 12.7671 15.5928 14.1512 14.2335 15.0813L14.2144 15.2051L17.2409 17.4969L17.4506 17.5174C19.3763 15.7789 20.4865 13.221 20.4865 10.1871Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6989 19.9313C13.4515 19.9313 15.7624 19.0454 17.4503 17.5174L14.2332 15.0813C13.3723 15.6682 12.2168 16.0779 10.6989 16.0779C8.0029 16.0779 5.7147 14.3395 4.89901 11.9366L4.77945 11.9466L1.63246 14.3273L1.59131 14.4391C3.26781 17.6945 6.71147 19.9313 10.6989 19.9313Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.89906 11.9366C4.68383 11.3165 4.55927 10.6521 4.55927 9.96559C4.55927 9.27902 4.68383 8.61467 4.88773 7.9946L4.88203 7.86254L1.6956 5.4436L1.59135 5.49208C0.900384 6.84299 0.503906 8.36002 0.503906 9.96559C0.503906 11.5712 0.900384 13.0881 1.59135 14.439L4.89906 11.9366Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6989 3.85336C12.6133 3.85336 13.9046 4.66168 14.641 5.33718L17.5182 2.59107C15.7511 0.985496 13.4515 0 10.6989 0C6.71147 0 3.26781 2.23672 1.59131 5.49214L4.88769 7.99466C5.7147 5.59183 8.0029 3.85336 10.6989 3.85336Z",
    fill: "#EB4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_54763"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.a028cda435e4b7374eff9a50970e9462.svg";
export { ForwardRef as ReactComponent };